module.exports = __webpack_public_path__ + "img/Boat-Outline.239aba1b.png";